import {
    UPDATE_CURRENT_ACCOUNT,
    UPDATE_CURRENT_ACCOUNT_FAILURE,
    UPDATE_CURRENT_ACCOUNT_SUCCESS,
} from 'store/actions/types';

export const updateCurrentAccount = (payload) => {
    return {
        type: UPDATE_CURRENT_ACCOUNT,
        payload: payload,
    };
};

export const updateCurrentAccountFailure = (error) => {
    return {
        type: UPDATE_CURRENT_ACCOUNT_FAILURE,
        payload: error,
    };
};

export const updateCurrentAccountSuccess = (response) => {
    return {
        type: UPDATE_CURRENT_ACCOUNT_SUCCESS,
        payload: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/updateCurrentAccount.js